export default __webpack_public_path__ + "static/img-platform-explain-29f4e2b2721da9e2c178ef8e743f7779.png";